// Voice-to-Text Configuration - Centralized Settings
export const VOICE_CONFIG = {
  // Supported languages
  languages: {
    'es': {
      code: 'es-ES',
      name: 'Español',
      flag: '🇪🇸'
    },
    'en': {
      code: 'en-US',
      name: 'English',
      flag: '🇺🇸'
    },
    'fr': {
      code: 'fr-FR',
      name: 'Français',
      flag: '🇫🇷'
    }
  },

  // Recording settings
  maxDuration: 30000, // 30 seconds in milliseconds
  continuous: false,
  interimResults: true,

  // Default language (can be changed by user)
  defaultLanguage: 'es',

  // Feature availability
  isPremiumFeature: true,

  // Error messages
  errorMessages: {
    'no-speech': 'No se detectó ningún discurso',
    'audio-capture': 'Error al capturar audio',
    'not-allowed': 'Permiso de micrófono denegado',
    'network': 'Error de conexión',
    'not-supported': 'Navegador no compatible con reconocimiento de voz',
    'aborted': 'Grabación cancelada'
  },

  // Status messages
  statusMessages: {
    'idle': 'Presiona para hablar',
    'listening': 'Escuchando...',
    'processing': 'Procesando...',
    'error': 'Error en grabación',
    'complete': 'Texto añadido'
  }
}

// Check if Speech Recognition is supported
export const isSpeechRecognitionSupported = () => {
  return 'webkitSpeechRecognition' in window || 'SpeechRecognition' in window
}

// Get Speech Recognition constructor
export const getSpeechRecognition = () => {
  return window.SpeechRecognition || window.webkitSpeechRecognition
}

// Sanitize transcribed text
export const sanitizeText = (text) => {
  if (!text || typeof text !== 'string') return ''

  // Remove any potential HTML/script content
  return text
    .replace(/<[^>]*>/g, '') // Remove HTML tags
    .replace(/[<>]/g, '') // Remove angle brackets
    .trim()
}